export default __webpack_public_path__ + "static/media/home.358f8595.svg";